import Index from '@tunnel-components/@pages/supervision/camera/created/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/created/index.ts